module.exports = __webpack_public_path__ + "img/downloads.d897cc62.svg";